import { clearPublisher } from '../jarvis/eventService';

export class WindowLocationHelper {
  // This will make sure we clean up any existing publishers before we leave the site
  static async href(url: string) {
    await clearPublisher();
    window.location.href = url;
  }
}
